/* istanbul ignore file */
/**
 * Primitive color palette configuration for NgKit theme.
 * Contains base color values used throughout the theme system.
 */

export const primitiveColors = {
  borderRadius: {
    none: '0',
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    full: '100%',
  },
  greymatter: {
    25: '#f8f9fb',
    50: '#f2f3f4',
    100: '#e7e8e9',
    150: '#d9dbdc',
    200: '#cacbcd',
    250: '#bebfc1',
    300: '#adafb1',
    350: '#9e9fa2',
    400: '#8f9194',
    450: '#828487',
    500: '#757779',
    550: '#686a6d',
    600: '#5c5d5f',
    650: '#505153',
    700: '#414244',
    750: '#363739',
    800: '#2a2a2b',
    850: '#212122',
    900: '#171718',
    950: '#0c0c0d',
  },
  stratosphere: {
    25: '#f5faff',
    50: '#ecf5ff',
    100: '#d7e9ff',
    150: '#c4deff',
    200: '#a7ceff',
    250: '#93c2fe',
    300: '#79b1fb',
    350: '#61a1f8',
    400: '#4a91f4',
    450: '#3582f0',
    500: '#1a71ef',
    550: '#0d63de',
    600: '#0a57c5',
    650: '#074cad',
    700: '#043e8e',
    750: '#033477',
    800: '#01285d',
    850: '#01204b',
    900: '#001736',
    950: '#000d1e',
  },
  error: {
    25: '#fff6f6',
    50: '#fff0f0',
    100: '#ffe1e1',
    150: '#ffd0d0',
    200: '#ffbab8',
    250: '#ffa8a5',
    300: '#ff8e89',
    350: '#ff746c',
    400: '#fa5b50',
    450: '#f04438',
    500: '#e52920',
    550: '#d40c0c',
    600: '#ba1312',
    650: '#a2130f',
    700: '#86110a',
    750: '#710d07',
    800: '#5a0803',
    850: '#4a0401',
    900: '#380100',
    950: '#230100',
  },
  warning: {
    25: '#fff9ee',
    50: '#fff3dd',
    100: '#ffe5b2',
    150: '#ffd685',
    200: '#ffc14b',
    250: '#ffaf14',
    300: '#ff9400',
    350: '#fe7900',
    400: '#f36500',
    450: '#e75200',
    500: '#d54400',
    550: '#ba4300',
    600: '#9e4000',
    650: '#863b00',
    700: '#6b3300',
    750: '#562c00',
    800: '#422200',
    850: '#341c00',
    900: '#251300',
    950: '#150a00',
  },
  success: {
    25: '#f3fbf5',
    50: '#e6f7eb',
    100: '#cfefdb',
    150: '#b3e7c9',
    200: '#9bd9b4',
    250: '#87cea2',
    300: '#6fbf8a',
    350: '#59b176',
    400: '#44a360',
    450: '#2f964d',
    500: '#188839',
    550: '#007b2e',
    600: '#006c31',
    650: '#005e30',
    700: '#004d2d',
    750: '#004028',
    800: '#003121',
    850: '#00271b',
    900: '#031b13',
    950: '#030f0a',
  },
  information: {
    25: '#f2fbfe',
    50: '#e5f7fd',
    100: '#c7eefb',
    150: '#a9e4f9',
    200: '#7ed7f6',
    250: '#59ccf3',
    300: '#25bcef',
    350: '#1dabe3',
    400: '#159ad6',
    450: '#0e8ccb',
    500: '#077cc0',
    550: '#036eb1',
    600: '#03619c',
    650: '#025487',
    700: '#02466f',
    750: '#013a5d',
    800: '#012d47',
    850: '#012439',
    900: '#011929',
    950: '#000e17',
  },
  ultraviolet: {
    25: '#fcf8ff',
    50: '#f9f2fe',
    100: '#f1e1fd',
    150: '#ead2fb',
    200: '#e0bff8',
    250: '#d6b1f1',
    300: '#c99ee7',
    350: '#bd8cde',
    400: '#b07bd6',
    450: '#a56bcd',
    500: '#995bc5',
    550: '#8e4bbd',
    600: '#8239b4',
    650: '#742ca5',
    700: '#611e90',
    750: '#521380',
    800: '#41056d',
    850: '#35035a',
    900: '#280144',
    950: '#19002b',
  },
  fireworks: {
    25: '#fff7fd',
    50: '#fef0fc',
    100: '#fddef8',
    150: '#fccdf5',
    200: '#fab4f0',
    250: '#f8a3eb',
    300: '#f488e4',
    350: '#ef6fdc',
    400: '#e954d3',
    450: '#e138c8',
    500: '#d124b8',
    550: '#bd1ba6',
    600: '#a81393',
    650: '#940d81',
    700: '#7b086b',
    750: '#68055a',
    800: '#530247',
    850: '#44013a',
    900: '#33002c',
    950: '#1f001b',
  },
  coralreef: {
    25: '#fff0f4',
    50: '#fff0f5',
    100: '#ffdfea',
    150: '#ffcedf',
    200: '#ffb7d0',
    250: '#fea5c3',
    300: '#fd8bb0',
    350: '#fa739c',
    400: '#f75784',
    450: '#f13a70',
    500: '#e71458',
    550: '#d00f50',
    600: '#b80b47',
    650: '#a2083e',
    700: '#860534',
    750: '#72032c',
    800: '#5a0123',
    850: '#49011d',
    900: '#370016',
    950: '#22000e',
  },
  infinity: {
    25: '#effcfb',
    50: '#dff9f6',
    100: '#b9f3ec',
    150: '#90ebe1',
    200: '#51e0d0',
    250: '#29d5c4',
    300: '#27c2b6',
    350: '#25b1a9',
    400: '#24a19b',
    450: '#22928f',
    500: '#208382',
    550: '#1d7575',
    600: '#1b6768',
    650: '#18595b',
    700: '#15494c',
    750: '#123d3f',
    800: '#0f2f31',
    850: '#0c2528',
    900: '#091a1c',
    950: '#050e0f',
  },
  mandarin: {
    25: '#fff8f3',
    50: '#fff2e8',
    100: '#ffe2cd',
    150: '#ffd2b2',
    200: '#ffbd8c',
    250: '#ffad6b',
    300: '#ff9434',
    350: '#fa7c00',
    400: '#e76f00',
    450: '#d56200',
    500: '#c25700',
    550: '#b04c00',
    600: '#9d4100',
    650: '#8b3700',
    700: '#742c00',
    750: '#612400',
    800: '#4c1b00',
    850: '#3e1500',
    900: '#2d0e00',
    950: '#190800',
  },
  submarine: {
    25: '#fff9ec',
    50: '#fff3d9',
    100: '#ffe4a6',
    150: '#ffd57b',
    200: '#ffc144',
    250: '#ffaf14',
    300: '#f19d00',
    350: '#dd8e00',
    400: '#ca8100',
    450: '#b97500',
    500: '#a76900',
    550: '#965d00',
    600: '#845200',
    650: '#744700',
    700: '#5f3a00',
    750: '#503000',
    800: '#3e2400',
    850: '#321d00',
    900: '#231400',
    950: '#130b00',
  },
  transparentblack: {
    10: '#00000003',
    20: '#00000005',
    30: '#00000008',
    40: '#0000000a',
    50: '#0000000d',
    60: '#0000000f',
    70: '#00000012',
    80: '#00000014',
    90: '#00000017',
    100: '#0000001a',
    120: '#0000001f',
    150: '#00000026',
    200: '#00000033',
    300: '#0000004d',
    400: '#00000066',
    500: '#00000080',
    600: '#00000099',
    700: '#000000b3',
    800: '#000000cc',
    900: '#000000e6',
    1000: '#000000ff',
  },
  transparentwhite: {
    10: '#ffffff03',
    20: '#ffffff05',
    30: '#ffffff08',
    40: '#ffffff0a',
    50: '#ffffff0d',
    60: '#ffffff0f',
    70: '#ffffff12',
    80: '#ffffff14',
    90: '#ffffff17',
    100: '#ffffff1a',
    120: '#ffffff1f',
    150: '#ffffff26',
    200: '#ffffff33',
    300: '#ffffff4d',
    400: '#ffffff66',
    500: '#ffffff80',
    600: '#ffffff99',
    700: '#ffffffb3',
    800: '#ffffffcc',
    900: '#ffffffe6',
    1000: '#ffffffff',
  },
  neutral: {
    0: '#ffffff',
    1000: '#222222',
  },
};
